<template>
  <PbDialog
    :dialog-title="dialogTitle"
    :loading="loading"
    :state="state"
    @close="cancel"
  >
    <slot />

    <template #footer>
      <DialogActions
        :loading="loading"
        :cancel-text="cancelText"
        :confirm-text="confirmText"
        :focus-cancel="focusCancel"
        :focus-confirm="focusConfirm"
        :cancel-style="cancelStyle"
        :confirm-style="confirmStyle"
        @cancel="cancel"
        @confirm="confirm"
      />
    </template>
  </PbDialog>
</template>

<script setup>
import { toRef, watch } from 'vue'
import useHotkeys, { KEYS } from '@nicolaudie-group/ng-ui-kit/composables/useHotkeys'
import PbDialog from '@/components/PbDialog.vue'
import DialogActions from '@/components/DialogActions/DialogActions.vue'

const props = defineProps({
  state: { type: Boolean, default: true },
  dialogTitle: { type: String, default: '' },
  loading: { type: Boolean, default: false },
  closeImmediatelyOnConfirm: { type: Boolean, default: false },
  cancelText: { type: String, default: 'pb2.confirmDialog.defaultCancelLabel' },
  confirmText: { type: String, default: 'pb2.confirmDialog.defaultConfirmLabel' },
  focusCancel: { type: Boolean, default: false },
  focusConfirm: { type: Boolean, default: true },
  cancelStyle: { type: String, default: '' },
  confirmStyle: { type: String, default: 'success' },
})

const emit = defineEmits(['close', 'confirm', 'cancel'])

const hotkeyEnabled = toRef(props, 'state')

const { active: enterPressed } = useHotkeys(KEYS.Enter, {
  shift: false,
  alt: false,
  meta: false,
  ctrl: false,
  exact: true,
  enabled: hotkeyEnabled,
  disableInButton: true,
})

function confirm() {
  // When the confirm button of the dialog is clicked or enter is pressed
  if (props.closeImmediatelyOnConfirm) {
    emit('close')
  }
  emit('confirm')
}

function cancel() {
  if (!props.loading) {
    // When the close button or the overlay of the dialog is clicked or escape is pressed
    // OR
    // When the cancel button of the dialog is clicked
    emit('close')
    emit('cancel')
  }
}

watch(enterPressed, () => {
  if (enterPressed.value) {
    confirm()
  }
})
</script>
